import { ref } from 'vue'

type RecordPickerTab = 'search' | 'create'

export function useRecordPicker() {
  const isOpen = ref(false)
  const initialTab = ref<RecordPickerTab>('search')

  const openPicker = (tab: RecordPickerTab = 'search') => {
    initialTab.value = tab
    isOpen.value = true
  }
  const closePicker = () => {
    isOpen.value = false
  }

  return { isOpen, initialTab, openPicker, closePicker }
}
